module.exports = __webpack_public_path__ + "static/expertPreview2-7b9521f0500a0a42a4098e503f2a7ded.png";